import { captureError } from '@src/utils/errors'
import { LOCAL_OR_PLAYGROUND } from '@src/utils/localOrPlayground'
import { getOrSetVCookie } from '@src/utils/vCookie'
import { createLogic } from 'redux-logic'
import { getType } from 'typesafe-actions'
import { initializeAnalytics } from '../app/actions'
import { handleFreshToken, logout } from '../auth/actions'
import { getCheggUserUuid } from '../auth/selectors'
import { getPageSubGroup } from '../gtm/helper'
import { resolveRioPromise } from '../optimizely/optimizely'
import { getCookieDomain } from '../site/selectors'
import { RootState } from '../types'
import { getAuthState, getSubscriptionStatus, productMap } from './helpers'
import { initializeWtaClient } from './rioAnalytics'
import { getRioClient } from './rioAnalytics'
import { getUpdatedView } from './utils'
import { getExpCookie } from './utils/getExpCookie'
import { AllocationMap, getMemoizedFeatureFlags } from './utils/getMemoizedFeatureFlags'

export const initializeAnalyticsLogic = createLogic<RootState>({
  type: getType(initializeAnalytics),
  process({ getState }, dispatch, done) {
    const state = getState()

    let allocationMap: AllocationMap | undefined
    try {
      const featureFlags = getMemoizedFeatureFlags()
      allocationMap = featureFlags.allocationMap
    } catch (e) {}

    const LOG_EVENT_LAMBDA_URL = LOCAL_OR_PLAYGROUND
      ? 'https://analytics.test.cheggnet.com/rio-service-web/rest/rio-events/batch'
      : 'https://analytics.chegg.com/rio-service-web/rest/rio-events/batch'

    initializeWtaClient({
      endpoint: LOG_EVENT_LAMBDA_URL,
      appId: 'wfe',
      property: state.site,
      authState: getAuthState(state),
      cheggUuid: getCheggUserUuid(state),
      testCells: allocationMap || {},
      uvn: getOrSetVCookie(getCookieDomain(state.site)) || '',
      clientExperiments: getExpCookie(),
      errorHandler: captureError,
      subscriptions: [
        { product: productMap[state.site], status: getSubscriptionStatus(state) },
      ],
      view: getUpdatedView({ site: state.site, page: getPageSubGroup(state) }),
    })
    resolveRioPromise()
    done()
  },
})

export const authStateLogic = createLogic<RootState>({
  type: [getType(handleFreshToken), getType(logout)],
  process({ getState }, dispatch, done) {
    const state = getState()
    const authState = getAuthState(state)
    const cheggUuid = getCheggUserUuid(state)
    getRioClient().updateState({
      authState,
      subscriptions: [
        {
          status: getSubscriptionStatus(state),
          product: productMap[state.site],
        },
      ],
      cheggUuid,
    })
    done()
  },
})

export default [initializeAnalyticsLogic, authStateLogic]



// WEBPACK FOOTER //
// ./src/state/analytics/logic.ts